/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'
export const MarketingSurface = {
	CustomerAppFeed: 'CUSTOMER_APP_FEED',
	CheckoutScreen: 'CHECKOUT_SCREEN'
} as const
export type MarketingSurfaceType = (typeof MarketingSurface)[keyof typeof MarketingSurface]
export const ContentBlockKind = {
	Static: 'STATIC',
	CampaignZone: 'CAMPAIGN_ZONE'
} as const
export type ContentBlockKindType = (typeof ContentBlockKind)[keyof typeof ContentBlockKind]
export const ContentBlockType = {
	Banner: 'BANNER',
	List: 'LIST',
	Modal: 'MODAL',
	Separator: 'SEPARATOR',
	Custom: 'CUSTOM'
} as const
export type ContentBlockTypeType = (typeof ContentBlockType)[keyof typeof ContentBlockType]
export type ContentBlock = {
	uuid: string
	position: number
	kind: ContentBlockKindType
	type?: ContentBlockTypeType
	data: any
	assetUuids: string[]
}
export const MarketingContentStatus = {
	Draft: 'DRAFT',
	Published: 'PUBLISHED'
} as const
export type MarketingContentStatusType = (typeof MarketingContentStatus)[keyof typeof MarketingContentStatus]
export type MarketingContent = {
	uuid: string
	name: string
	description?: string
	status: MarketingContentStatusType
	startsAt?: number
	endsAt?: number
	blockCount: number
	layoutCount: number
	createdAt: number
	updatedAt: number
}
export type MarketingContentWithBlocks = {
	uuid: string
	name: string
	description?: string
	status: MarketingContentStatusType
	startsAt?: number
	endsAt?: number
	blocks: ContentBlock[]
	createdAt: number
	updatedAt: number
}

export const zMarketingSurface = z.enum(['CUSTOMER_APP_FEED', 'CHECKOUT_SCREEN'])
export const zContentBlockKind = z.enum(['STATIC', 'CAMPAIGN_ZONE'])
export const zContentBlockType = z.enum(['BANNER', 'LIST', 'MODAL', 'SEPARATOR', 'CUSTOM'])
export const zContentBlock = z.object({
	uuid: z.string(),
	position: z.number(),
	kind: zContentBlockKind,
	type: zContentBlockType.optional(),
	data: z.any(),
	assetUuids: z.array(z.string())
})
export const zMarketingContentStatus = z.enum(['DRAFT', 'PUBLISHED'])
export const zMarketingContent = z.object({
	uuid: z.string(),
	name: z.string(),
	description: z.string().optional(),
	status: zMarketingContentStatus,
	startsAt: z.number().optional(),
	endsAt: z.number().optional(),
	blockCount: z.number(),
	layoutCount: z.number(),
	createdAt: z.number(),
	updatedAt: z.number()
})
export const zMarketingContentWithBlocks = z.object({
	uuid: z.string(),
	name: z.string(),
	description: z.string().optional(),
	status: zMarketingContentStatus,
	startsAt: z.number().optional(),
	endsAt: z.number().optional(),
	blocks: z.array(zContentBlock),
	createdAt: z.number(),
	updatedAt: z.number()
})
